module.exports = __webpack_public_path__ + "media/images/application/default/default-culture-c049826e2f13fda215ad2daf4e1e2028.jpg";